import { useMemo } from 'react';
import { Differ, Viewer } from 'json-diff-kit';
import 'json-diff-kit/dist/viewer.css';
import './diff-viewer-unified.css';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface DiffViewerProps {
  expected: unknown;
  actual: unknown;
  className?: string;
  viewMode?: 'split' | 'unified';
}

export function DiffViewer({ expected, actual, className, viewMode = 'split' }: DiffViewerProps) {
  const diff = useMemo(() => {
    const differ = new Differ({
      detectCircular: true,
      showModifications: true,
      arrayDiffMethod: 'lcs',
    });
    return differ.diff(expected, actual);
  }, [expected, actual]);

  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle>Comparison Results</CardTitle>
      </CardHeader>
      <CardContent>
        <div className={`overflow-auto max-h-[600px] border rounded-md p-4 bg-background ${viewMode === 'unified' ? 'diff-unified-mode' : ''}`}>
          <Viewer
            diff={diff}
            indent={2}
            lineNumbers={true}
            highlightInlineDiff={true}
            inlineDiffOptions={{ mode: 'word', wordSeparator: ' ' }}
            syntaxHighlight={{ theme: 'monokai' }}
          />
        </div>
      </CardContent>
    </Card>
  );
}
